import React, { useState, useEffect, useRef } from 'react';
import {Link, useLocation } from 'react-router-dom';


const TaxDetailsList = ({ onBack }) => {
    const [activeTab, setActiveTab] = useState('poInfo'); 
const handleTabClick = (tab) => {
    setActiveTab(tab);
};
const handleBackClick = () => {
    // Example back navigation, you can customize this as needed
    window.history.back();
};
const location = useLocation();
    const taxDetails = location.state?.taxDetails;
    const proformainvoice=location.state;
    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid">
                    {/* Page Title */}
                    <div className="row">
                        <div className="col-12">
                            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                <h4 className="mb-sm-0 font-size-18">Tax Invoice List</h4>
                                <div className="page-title-right"></div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12">
                            <div className="email-leftbar card">
                                <div className="card-body">
                                    <a
                                        onClick={() => handleTabClick('poInfo')}
                                        className={`list-group-item list-group-item-action ${activeTab === 'poInfo' ? 'active-tab' : ''}`}
                                    >
                                        Tax Details
                                    </a>
                                    <div className="button-container">
                                        <button onClick={handleBackClick} className="btn btn-secondary mb-4 back">Back</button>
                                    </div>
                                </div>
                            </div>

                            {/* Right Content */}
                            <div className="email-rightbar">
                                <div className="card">
                                    <div className="card-body">
                                        {activeTab === 'poInfo' && (
                                            <div>
                                                <h4 className="mb-sm-0 font-size-18">Tax Invoice List</h4>
                                               <br/><br/>
      
                <table id="datatable" className="table table-bordered dt-responsive nowrap w-100">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Reference Number</th>
                            <th>Total Amount</th>

                            <th>VAT Amount</th>
                            <th>Total with VAT</th>
                        </tr>
                    </thead>
                    <tbody>
                        {taxDetails && (
                            <tr>
                                <td>1</td>
                                <td><Link to={`/tax-invoice/details/${taxDetails?.id}`} className="dropdown-item">{taxDetails.ref_no}</Link></td>
                                <td>{taxDetails.amount_received}</td>
                                <td>{taxDetails.vat_amount}</td>

                                <td>{taxDetails.total_with_vat}</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
    )}
    </div>
</div>
</div>
</div>
</div>
</div>
</div></div>
    );
};

export default TaxDetailsList;
